var map = {
	"./music-instructions.json": 3106,
	"./music-library-intro2024.json": 3107,
	"./music-library-launch2024.json": 3108,
	"./music-progression.json": 3109,
	"./startSourcesAdvanced.json": 3110,
	"./startSourcesSimple.json": 3111,
	"./startSourcesSimple2.json": 3112,
	"./startSourcesTracks.json": 3113
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2883;